import { h } from 'preact';

/**
 * MundialButton Component
 * A button component featuring the World Cup 2026 theme
 * 
 * @param {string} className - Additional CSS classes to apply
 * @param {Function} onClick - Click handler function
 * @param {boolean} disabled - Whether the button is disabled
 * @param {Object} mundial2026Text - Translated text for "Mundial 2026"
 */
const MundialButton = ({ className = '', onClick, disabled = false }) => {
  const handleClick = (e) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!disabled && onClick) {
        onClick(e);
      }
    }
  };

  return (
    <button
      className={`mundial-button ${className}`.trim()}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      type="button"
      aria-label="Soccer ball and trophy"
    >
      <span className="mundial-button-icon" role="img" aria-label="Soccer ball and trophy">
        ⚽🏆
      </span>
    </button>
  );
};

export default MundialButton;

